var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.workflowId)?_c('ExecutionHistory',{key:_vm.workflowId,attrs:{"workflowId":_vm.workflowId,"workflowType":_vm.WorkflowType.Analytics,"facetLabelPreprocess":_vm.facetLabelPreprocess,"routeName":"history"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }